import { GetStaticProps, GetStaticPaths } from 'next';
import { NextSeo } from 'next-seo';
import Loader from 'react-loader-spinner';
import { withAuth, useAuth } from '~/auth';
import { useTranslate } from '~/i18n';
import { getLanguagesPaths } from '~/utils/translate';
import ProfileContentWrapper from '~/components/profile-page/content-wrapper';
import VoucherContent from '~/components/profile-page/vouchers/content-section';

/**
 * This page contains user voucher credit details: voucher balance, active
 * vouchers, redeemed vouchers, and balance history
 */

const VouchersCredit = () => {
   const { translate } = useTranslate();
   const { authenticated, user } = useAuth();

   return !authenticated || !user ? (
      <div className="flex justify-center mt-32">
         <Loader type="Puff" color="#212529" width={59} height={59} />
      </div>
   ) : (
      <ProfileContentWrapper>
         <NextSeo title={translate({ id: 'vouchers:vouchers' })} />
         <VoucherContent />
      </ProfileContentWrapper>
   );
};

VouchersCredit.smallFooter = true;

export const getStaticPaths: GetStaticPaths = async () => {
   return {
      paths: getLanguagesPaths(),
      fallback: false,
   };
};

/******************************************************************
 *
 *  THIS PAGE IS USING STATIC SITE GENERATION
 *
 ******************************************************************/

export const getStaticProps: GetStaticProps = async () => {
   return {
      props: {},
   };
};

export default withAuth(VouchersCredit, { comeback: true });
